import { render, staticRenderFns } from "./DescriptionAssuranceVoyage.vue?vue&type=template&id=9b19ac10&scoped=true"
import script from "./DescriptionAssuranceVoyage.vue?vue&type=script&lang=js"
export * from "./DescriptionAssuranceVoyage.vue?vue&type=script&lang=js"
import style0 from "./DescriptionAssuranceVoyage.vue?vue&type=style&index=0&id=9b19ac10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b19ac10",
  null
  
)

export default component.exports